module.exports = __webpack_public_path__ + "static/media/post-14.99b3e497.jpg";